import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Paper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@material-ui/core";
import * as Yup from "yup";
import { DropzoneArea } from 'material-ui-dropzone'
import { BackButton, capitalize } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: 'right'
    },
    checkbox: {
        marginTop: "2%"
    }
});

const SecurazeToolForm = props => {
    const { classes, formSettings, initialValues, edit, handleUpload, loading, handleSubmit, translations, fileName } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                enableReinitialize={false}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit, isSubmitting } = formikProps;

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                      }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="ToolName"
                                value={values.ToolName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ToolName && touched.ToolName)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["tool_type"] || 'Tool type'}</InputLabel>
                                <Select
                                    name="Status"
                                    value={values.Status}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Status && touched.Status)}
                                    placeholder={translations["tool_type"] || 'Tool type'}
                                    label={translations["tool_type"] || 'Tool type'}
                                    margin={"dense"}
                                    fullWidth={true}
                                >
                                    <MenuItem key={"test"} value={"test"}>
                                        {translations['test'] || 'Test'}
                                    </MenuItem>
                                    <MenuItem key={"release"} value={"release"}>
                                        {translations['release'] || 'Release'}
                                    </MenuItem>
                                    <MenuItem key={"demo"} value={"demo"}>
                                        {translations['demo'] || 'Demo'}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            {!edit ?
                                <div className={classes.img}>
                                    <DropzoneArea
                                        filesLimit={1}
                                        maxFileSize={5368709120}
                                        acceptedFiles={['.exe', '.zip', '.7z', '.rar']}
                                        getFileRemovedMessage={(fileName) => {
                                            const text = translations ? (
                                                capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                                            ) : `File ${fileName} removed.`
                    
                                            return text;
                                        }}
                                        getFileAddedMessage={(fileName) => {
                                            const text = translations ? (
                                                capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                                            ) : `File ${fileName} successfully added.`
                    
                                            return text;
                                        }}
                                        getFileLimitExceedMessage={(filesLimit) => {
                                            const text = translations ? (
                                                capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                                            ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`
                    
                                            return text;
                                        }}
                                        getDropRejectMessage={(rejectedFile) => {
                                            const text = translations ? (
                                                capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                                            ) : `File was rejected.`
                    
                                            return text;
                                        }}
                                        dropzoneText={translations['drag_and_drop_file'] || 'Drag and drop file here'}
                                        onChange={handleUpload}
                                    />
                                </div> : null}
                            <FormGroup className={classes['checkbox']}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            margin={"dense"}
                                            name={"ForAllCustomers"}
                                            checked={values.ForAllCustomers}
                                            onChange={handleChange}
                                            color={'primary'}
                                        />
                                    }
                                    label={translations['for_all_customers'] || 'For all customers'}
                                />
                            </FormGroup>
                            <div className={classes.buttons}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={Object.keys(fileName).length > 0 ? isSubmitting || loading || !(isValid && dirty) : true}
                                    >
                                        {loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(SecurazeToolForm);

